import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Typography,
  Button,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";
import toast from "react-hot-toast";
import { axiosConfig } from "../../axios/axiosConfig";
const ReferralDataCommissions = ({ open, onClose, userId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userId) fetchData();
  }, [userId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axiosConfig({
        method: "get",
        url: "/referral/user-referral-data/",
        params: { user_id: userId },
      });
      setData(res?.data);
    } catch (e) {
      console.error("Fetch failed:", e);
      const errMsg = e.response.data.response || e.message || "Fetch failed";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Referral Data for User {userId}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <CircularProgress />
        ) : data ? (
          <>
            <Typography fontWeight={600} mb={1}>
              Total Referral Amount: ₹{data.total_referral_amount}
            </Typography>
            <Typography fontWeight={600} mb={2}>
              Eligible Referral Amount: ₹{data.eligibal_referral_amount}
            </Typography>

            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Username</TableCell>
                  <TableCell>Phone No</TableCell>
                  <TableCell>Plan Name</TableCell>
                  <TableCell>Referral Amount</TableCell>
                  <TableCell>Withdrawal Status</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.total_referral_data?.map((item) => (
                  <TableRow key={`total-${item.id}`}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.username}</TableCell>
                    <TableCell>{item.phoneno || "-"}</TableCell>
                    <TableCell>{item.plan_name || "-"}</TableCell>
                    <TableCell>₹{item.referral_amount}</TableCell>
                    <TableCell>
                      {item.withdrawal_status
                        ? "Withdrawn"
                        : "Not Yet Withdrawn"}
                    </TableCell>
                    <TableCell>
                      {new Date(item.created_at).toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        ) : (
          <Typography>No referral data available.</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReferralDataCommissions;
